//Step for progress bar, coming from 100 divided by happy path flow length
export const step = 7;
